import { isSet } from "../utils/isSet";

export const setupGalleryController = (emblaApi) => {
    const slideNodes = emblaApi.slideNodes();
    const triggers = document.querySelectorAll('[data-gallery-trigger]');

    triggers.forEach((trigger) => {
        const imageID = trigger.dataset.galleryImageId;
        const taxonomyID = trigger.dataset.galleryTaxonomyId;

        if(!isSet(imageID) || !isSet(taxonomyID)) return;

        trigger.addEventListener("click", (e) => {
            slideNodes.forEach((node, index) => {
                if(!isSet(node.dataset.galleryImageId)) return;

                if(node.dataset.galleryImageId !== imageID) return;

                emblaApi.scrollTo(index, true);
            })
        });
    });

    const destroyIfDone = (emblaApi, eventName) => {
    }

    return destroyIfDone;
}
  